import styled from 'styled-components';
import { theme } from '../../../global';

export const TornamentsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 840px;
  flex-direction: column;
  margin: auto;
  gap: ${theme.spacings.s32};
  padding: 0 0 ${theme.spacings.s40} 0;

  @media (max-width: 1100px) {
    width: 500px;
    padding: ${theme.spacings.s24} 0;
  }

  @media (max-width: 500px) {
    width: 343px;
    padding: ${theme.spacings.s24} 0;
    gap: ${theme.spacings.s24};
  }
`;

export const Title = styled.h1`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 32px;
  line-height: 43.53px;

  @media (max-width: 900px) {
    font-size: 24px;
  }
`;

export const TournamentsCount = styled.span`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 16px;
  line-height: 19.5px;
  color: ${theme.colors.secondaryText};
  text-transform: uppercase;
  width: 100%;
`;

export const TournamentsItemsWrapper = styled.div`
  flex-direction: column;
  width: 100%;
  display: flex;
  gap: ${theme.spacings.s24};
`;

export const TournamentsHeder = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;
